<template>
  <v-container>
    <v-card fluid class="my-0 py-0" min-height="350px">
      <v-overlay :absolute="true" :value="loadingFile" z-index="10">
        <v-progress-circular
          v-show="loadingFile"
          :size="50"
          color="success"
          indeterminate
        >
        </v-progress-circular>
      </v-overlay>

      <v-card>
        <v-toolbar dense color="success">
          <span class="subtitle-1 font-weight-black" style="color: white"
            >Arquivos do Cliente</span
          >
        </v-toolbar>

        <div
          class="large-12 medium-12 small-12 filezone"
          v-show="privilegioManutencaoArquivo"
        >
          <!--<input type="file" id="files" multiple @change="handleFiles" accept="image/x-png,image/gif,image/jpeg,application/pdf, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,.doc,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"/> -->
          <input type="file" id="files" multiple @change="handleFiles" />
          <p>Arraste aqui <br />ou clique para procurar</p>
        </div>
      </v-card>

      <v-card v-show="images.length">
        <v-row class="my-0 py-0 px-5">
          <v-col
            v-for="(item, key) in $v.images.$each.$iter"
            :key="
              item.id.$model ? (item.id.$model > 0 ? item.id.$model : key) : key
            "
            class="d-flex child-flex"
            cols="6"
            md="2"
          >
            <v-hover template v-slot:default="{ hover }">
              <v-card
                elevation="5"
                :loading="item.loading.$model"
                :outlined="false"
              >
                <v-fade-transition>
                  <v-overlay
                    v-if="item.$model.isMultiSelecionado"
                    absolute
                    color="#036358"
                    z-index="3"
                  >
                    <!--<h3 min-width="85" z-index="3">ZIP</h3>-->
                    <v-chip class="mb-16" color="success">
                      ** Selecionado **
                    </v-chip>
                  </v-overlay>
                </v-fade-transition>

                <v-img
                  :src="item.preview.$model"
                  :src-lazy="item.preview.$model"
                  aspect-ratio="1"
                  class="grey lighten-2"
                >
                  <div
                    class="text-center"
                    v-show="item.downloadFile.$model"
                    style="background-color: silver; height: 100%"
                  >
                    <v-progress-circular
                      :rotate="-90"
                      :size="70"
                      :width="8"
                      :value="item.progressFile.$model"
                      z-index="10"
                      color="success"
                      style="top: 25px"
                    >
                      {{ item.progressFile.$model }}
                    </v-progress-circular>
                  </div>
                  <v-fade-transition>
                    <v-overlay
                      v-if="
                        hover &&
                        item.id.$model &&
                        !item.isErro.$model &&
                        !item.downloadFile.$model &&
                        !item.$model.isMultiSelecionado
                      "
                      absolute
                      color="#036358"
                      z-index="3"
                    >
                      <v-row>
                        <v-btn
                          min-width="85"
                          z-index="3"
                          @click="downloadURL(item.$model)"
                          >Baixar</v-btn
                        >
                      </v-row>
                      <v-row>
                        <v-btn
                          min-width="85"
                          z-index="3"
                          @click="vizualizarItem(item.$model)"
                          >Ver</v-btn
                        >
                      </v-row>
                    </v-overlay>
                  </v-fade-transition>

                  <v-overlay
                    v-show="item.isErro.$model"
                    absolute
                    value="true"
                    opacity="0.6"
                  >
                    <v-alert
                      color="red"
                      class="text-center my-0 py-0"
                      style="opacity: 0.6"
                    >
                      <v-icon class="px-1 py-1 mx-0 my-0"
                        >mdi-close-octagon</v-icon
                      >
                      <v-row
                        align="center"
                        no-gutters
                        class="px-0 py-0 mx-0 my-0"
                      >
                        <v-col class="grow"> Não Enviado </v-col>
                      </v-row>
                    </v-alert>
                  </v-overlay>
                  <v-chip
                    class="mx-0 my-0 px-1 py-0"
                    color="success"
                    label
                    text-color="white"
                  >
                    <span style="font-size: 10px">
                      File: {{ item.ext.$model ? item.ext.$model : "n/a"
                      }}<br />
                      size:
                      {{
                        item.size.$model && item.size.$model > 0
                          ? Math.round(item.size.$model / 1024) + " Kb"
                          : "ND"
                      }}
                    </span>
                  </v-chip>
                </v-img>

                <v-card-text class="pb-0 mb-0">
                  <v-text-field
                    v-model="item.nome.$model"
                    label="descrição"
                    :error-messages="validacaoForm(item.nome, '')"
                    v-remove-acentos="'uppercase'"
                  >
                  </v-text-field>
                </v-card-text>

                <v-tooltip top dark color="grey darken-3">
                  <template v-slot:activator="{ on: tooltip }">
                    <v-btn
                      v-show="privilegioManutencaoArquivo"
                      :disabled="item.isUploading.$model"
                      class="px-0 py-0 mx-0 my-0 elevationbtn"
                      x-small
                      absolute
                      dark
                      fab
                      top
                      right
                      z-index="5"
                      style="top: 5px; right: 5px"
                      @click="removeFile(item.$model, key)"
                      :color="item.id.$model ? 'success' : 'blue'"
                      v-on="{ ...tooltip }"
                    >
                      <v-icon class="px-0 py-0 mx-o my-0" large
                        >mdi-close-circle</v-icon
                      >
                    </v-btn>
                  </template>
                  <span class="white--text text--darken-4 subtitle-2"
                    >Remover Arquivo</span
                  >
                </v-tooltip>

                <v-tooltip top dark color="grey darken-3">
                  <template v-slot:activator="{ on: tooltip }">
                    <v-btn
                      v-if="item.id.$model"
                      absolute
                      x-small
                      dark
                      fab
                      bottom
                      right
                      z-index="5"
                      style="bottom: 80px; right: 3px"
                      @click="
                        item.$model.isMultiSelecionado =
                          !item.$model.isMultiSelecionado
                      "
                      :color="'transparent'"
                      v-on="{ ...tooltip }"
                    >
                      <v-icon
                        class="px-0 py-0 mx-o my-0"
                        color="teal darken-4"
                        large
                        v-if="item.$model.isMultiSelecionado"
                      >
                        mdi-check-underline-circle
                      </v-icon>
                      <v-icon
                        class="px-0 py-0 mx-o my-0"
                        color="teal darken-4"
                        large
                        v-else
                      >
                        mdi-checkbox-blank-circle-outline
                      </v-icon>
                    </v-btn>
                  </template>
                  <span class="white--text text--darken-4 subtitle-2"
                    >Selecionar Arquivo</span
                  >
                </v-tooltip>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>
      </v-card>
      <v-row class="text-center">
        <v-btn
          color="success"
          class="font-weight-light"
          @click="sendFiles"
          v-show="contadorEnviar > 0"
          :disabled="esconderBtnSendFiles"
          >Enviar {{ contadorEnviar }} arquivo(s)</v-btn
        >
        <v-btn
          rounded
          color="success"
          class="font-weight-light"
          @click="downloadFiles"
          dark
          v-if="contadorDownload > 0"
          >Download {{ contadorDownload }} arquivo(s)</v-btn
        >
        <v-btn
          rounded
          color="red darken-3"
          class="font-weight-light"
          @click="removeVariosFilesSelecionados"
          dark
          v-if="contadorDownload > 0 && privilegioManutencaoArquivo"
          >Excluir {{ contadorDownload }} arquivo(s)</v-btn
        >
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import apiClient from "@/plugins/axios";
import { erroArrayToString } from "@/utils/trataErroRetornoApi";
import validacaoForm from "@/mixins/validacaoForm";
import procImages from "@/mixins/procImages";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import { mapMutations } from "vuex";
import utilsLocal from "@/utils/filesDropBox";
import privilegiosUsuario from "@/utils/privilegiosUsuario";

export default {
  name: "ArquivosCliente",
  props: ["pessoa_id"],
  mixins: [validacaoForm, procImages],
  data: function () {
    return {
      erros: "",
      images: [],
      gravados: [],
      dialog: false,
      loadingFile: false,
      progressFile: null,
      dialogIMG: false,
      imagemSel: null,
      dialogPDF: false,
      pdfSel: null,
      window: {
        width: 0,
        height: 0,
      },
      fileDownload: null,
      esconderBtnSendFiles: true,
      folderExisteDropBox: false,
      filesErrorUpload: [],
    };
  },
  validations: {
    images: {
      $each: {
        nome: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(60),
          errors: [],
        },
        preview: { errors: [] },
        isErro: { errors: [] },
        isEnviar: { errors: [] },
        id: { errors: [] },
        loading: { errors: [] },
        downloadFile: { errors: [] },
        progressFile: { errors: [] },
        ext: { errors: [] },
        size: { errors: [] },
        isUploading: { errors: [] },
      },
    },
  },
  async created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.filesErrorUpload = [];
    await this.$nextTick();
    await this.buscarArquivos();
    this.ajustaArquivosPreview();
  },
  watch: {
    images(novo, velho) {
      return novo;
    },
  },
  methods: {
    ...mapMutations({
      setFile: "processo/SET_FILE",
      resetErros: "cliente/ERASE_ERROS",
      commitErro: "cliente/SET_ERROS",
      commitLoadingStore: "cliente/SET_LOADING_STORE",
    }),
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    fecharModalIMG() {
      this.fileDownload = null;
      this.dialogIMG = false;
    },
    downloadFileFromView() {
      let item = this.fileDownload[0];
      let file = this.fileDownload[1];
      const link = document.createElement("a");
      var fileBlob = new Blob([file], { type: `${item.type}` });
      var fileURL = URL.createObjectURL(fileBlob);
      link.setAttribute("href", fileURL);
      link.setAttribute("download", item.nome);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    async updateNameFile(i, filename) {
      //console.log('original', this.imagesCompare[i].nome)
      // console.log('tela', filename.$model)
      // console.log(this.imagesCompare[i])
      // console.log(this.imagesCompare.indexOf(i))
      if (!this.imagesCompare[i]) return;
      console.log("achou");
      let nameOld = this.imagesCompare[i].nome;
      let nameNew = filename.$model;
      if (nameOld == nameNew) return;

      try {
        var resp = await this.updateNameFileDropbox(this.images[i], nameNew);
        if (resp) {
          this.images[i].nome = resp.name;
          this.images[i].path_lower = resp.path_lower;
          console.log("upd", this.images[i]);
        }
      } catch (e) {
        console.log("Erro", e);
      }
    },

    async vizualizarItem(item) {
      this.resetErros();
      item.progressFile = 0;
      item.downloadFile = true;
      // let payload = {file: {processo_id: this.processo_id, filename: item.file}}
      let payload = { file: item.path_lower };
      utilsLocal
        .geraUrlToDownloadFile(`filecliente/download`, payload)
        .then(async (response) => {
          if (response.data.status) {
            item.url = response.data.url.link;
            try {
              var resp = await utilsLocal.downloadDropBoxByUrl(item);
            } catch (error) {
              this.$toaster.error(
                "Catch: Erro ao gerar vizualização do arquivo"
              );
              console.log(error);
            }
            item.downloadFile = false;
          } else {
            item.downloadFile = false;
            this.$toaster.error(
              "Servidor retornou status=false para download do arquivo"
            );
          }
        })
        .catch((e) => {
          item.downloadFile = false;
          console.log("Catch vizualizarItem", e);
          this.$toaster.error("Catch: Erro ao gerar vizualização do arquivo");
        });
    },

    async downloadURL(item) {
      this.resetErros();
      item.loadingFile = true;
      try {
        let payload = { file: item.path_lower };
        const response = await utilsLocal.geraUrlToDownloadFile(
          `filecliente/download`,
          payload
        );

        if (!response.data.status) {
          this.$toaster.error(
            "Servidor retornou status=false para download do arquivo"
          );
          return;
        }

        if (!response.data.url || !response.data.url.link) {
          this.commitErro({
            erros:
              "Erro ao tentar efetuar download. Impossível recuperar URL do arquivo.",
          });
          return;
        }

        item.url = response.data.url.link;
        const arquivo = await utilsLocal.downloadFileFromUrl(item);
        const fileBlob = new Blob([arquivo.data], { type: `${item.type}` });
        const fileURL = URL.createObjectURL(fileBlob);
        const fileName = `${item.nome}.${item.ext}`;
        const link = document.createElement("a");
        link.setAttribute("href", fileURL);
        link.setAttribute("download", fileName);
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(fileURL);
      } catch (e) {
        console.log("Catch downloadURL", e);
        this.$toaster.error("Erro ao efetuar download do arquivo");
      } finally {
        item.loadingFile = false;
      }
    },

    extraiNomeExt(fileName) {
      const nomeCompleto = (fileName || "").trim();
      const idxUltimoPonto = nomeCompleto.lastIndexOf(".");

      if (idxUltimoPonto <= 0) {
        return {
          nome: nomeCompleto || "arquivo",
          ext: "",
        };
      }

      if (idxUltimoPonto === nomeCompleto.length - 1) {
        return {
          nome: nomeCompleto.slice(0, -1) || "arquivo",
          ext: "",
        };
      }

      return {
        nome: nomeCompleto.slice(0, idxUltimoPonto),
        ext: nomeCompleto.slice(idxUltimoPonto + 1),
      };
    },

    async downloadFiles() {
      this.resetErros();
      this.loadingFile = true;
      try {
        const arquivos = this.retornaIDItensSelecionados(this.images);
        if (!arquivos.length) {
          this.$toaster.error("Nenhum arquivo selecionado para download");
          return;
        }

        const urls = await Promise.all(
          arquivos.map((item) => {
            let payload = { file: item.path_lower };
            return utilsLocal.geraUrlToDownloadFile(
              `filecliente/download`,
              payload
            );
          })
        );

        for (const item of urls) {
          if (!item.data.status) {
            this.$toaster.error(
              "Servidor retornou status=false para download do arquivo"
            );
            throw new Error("Abortando download devido a erro no servidor");
          }
        }

        let files = urls.map((item) => {
          const metadataName =
            item &&
            item.data &&
            item.data.url &&
            item.data.url.metadata &&
            item.data.url.metadata.name
              ? item.data.url.metadata.name
              : "";
          const { nome, ext } = this.extraiNomeExt(metadataName);
          return {
            url: item.data.url.link,
            nome,
            ext,
          };
        });
        await utilsLocal.downloadFilesInZipFile(files);
        this.images.forEach((item) => {
          if (item.isMultiSelecionado)
            item.isMultiSelecionado = !item.isMultiSelecionado;
        });
      } catch (e) {
        console.log("Catch downloadFiles", e);
        this.$toaster.error(
          "Erro ao efetuar download dos arquivos selecionados"
        );
      } finally {
        this.loadingFile = false;
      }
    },

    async handleFiles(event) {
      this.loadingFile = true;
      this.esconderBtnSendFiles = true;
      let uploadedFiles = event.target.files;
      for (var i = 0; i < uploadedFiles.length; i++) {
        await this.pushFileToArray(uploadedFiles[i]);
      }
      event.target.files = null;
      event.target.value = null;
      this.loadingFile = false;
      this.esconderBtnSendFiles = false;
    },
    async pushFileToArray(file) {
      var inExiste = false;
      const { nome } = this.extraiNomeExt(file.name.toUpperCase());
      let nameFile = nome;
      if (this.images.length) {
        for (let j = 0; j < this.images.length; j++) {
          if (nameFile === this.images[j].nome.toUpperCase()) {
            this.$toaster.error(`Arquivo ${file.name} já inserido`);
            return;
          }
        }
      }

      await utilsLocal
        .generateFileToUpload(file)
        .then((response) => {
          response.pessoa_id = this.pessoa_id;
          this.images.push(response);
        })
        .catch((error) => {
          this.$toaster.error(`Erro ao incluir arquivo ${file.name}`);
          console.log(error);
        });
    },

    //ao carregar arquivos da api, ajusta para mostrar na DOM
    async ajustaArquivosPreview() {
      this.images = [];
      this.imagesCompare = [];
      if (this.gravados.length) {
        this.gravados.forEach(async (item) => {
          let img = await this.montaItemArquivoPreview(item);
          this.images.push(Object.assign({}, img));
          this.imagesCompare.push(Object.assign({}, img));
        });
      }
      this.gravados = [];
    },

    async montaItemArquivoPreview(item) {
      var file = {
        id: item.id,
        pessoa_id: this.pessoa_id,
        nome: item.name,
        type: item.type,
        ext: item.extension,
        file: item.file,
        preview: item.preview.preview,
        arquivopessoa_id: item.arquivopessoa_id,
        size: item.size ? item.size : 0,
        path_lower: item.path_lower,
        loading: false,
        downloadFile: false,
        progressFile: null,
        isMultiSelecionado: false,
        isEnviar: false,
        isErro: false,
        tipo: "file",
        isUploading: false,
      };
      return file;
    },

    async sendFiles() {
      // console.log('Iniciou', this.$moment(new Date(), 'YYYY-MM-DD hh:mm:ss').format('DD/MM/YYYY hh:mm:ss'))
      this.resetErros();
      this.filesErrorUpload = [];
      this.esconderBtnSendFiles = true;
      if (!(await this.validaForm())) return;
      this.commitLoadingStore(true);
      for (var i = 0; i < this.images.length; i++) {
        if (this.images[i].isEnviar) {
          try {
            //console.log(`Disparado item ${i}`, this.$moment(new Date(), 'YYYY-MM-DD hh:mm:ss').format('DD/MM/YYYY hh:mm:ss'))
            await this.sendFile(this.images[i], i);
          } catch (e) {
            console.log(e);
          }
          //await sleep(2000);
        }
      }
      // console.log('Terminou', this.$moment(new Date(), 'YYYY-MM-DD hh:mm:ss').format('DD/MM/YYYY hh:mm:ss'))
      await this.buscarArquivos();
      await this.ajustaArquivosPreview();
      if (this.filesErrorUpload.length)
        this.images.push(...this.filesErrorUpload);
      this.esconderBtnSendFiles = false;
      this.commitLoadingStore(false);
    },

    async sendFile(item, key) {
      return new Promise(async (resolve, reject) => {
        let erro = null;

        this.resetErros();
        this.$v.images.$each.$iter[key].$touch();
        if (this.$v.images.$each.$iter[key].$anyError) {
          reject();
          return this.$v.images.$each.$iter[key];
        }

        item.loading = true;
        item.isErro = false;
        item.isUploading = true;
        item.name = `${item.nome}.${item.ext}`;

        var url = `filecliente`;

        utilsLocal
          .geraUrlDropBox(item, url, this.pessoa_id, this.folderExisteDropBox)
          .then((resp) => {
            //console.log(`geraUrlDropBox item ${key}`, this.$moment(new Date(), 'YYYY-MM-DD hh:mm:ss').format('DD/MM/YYYY hh:mm:ss'))
            if (!this.folderExisteDropBox) this.folderExisteDropBox = true;
            item.nameFileUpload = resp.filename;
            return utilsLocal.uploadFileToUrlDropBox(item, resp.urlupload);
          })

          .then(async (resp) => {
            resolve();
          })

          .catch((err) => {
            item.isErro = true;
            this.filesErrorUpload.push(item);
            reject(err);
          })

          .finally(() => {
            item.downloadFile = false;
            item.loading = false;
            item.isUploading = false;
          });
      });
    },

    async validaForm() {
      this.$v.images.$touch();
      if (!this.$v.images.$invalid) {
        return true;
      } else if (this.$v.images.$anyError) {
        return false;
      }
    },
    async updateNameFileDropbox(item, nameNew) {
      try {
        let sendRequest = { path_lower: item.path_lower, file_new: nameNew };
        const response = await apiClient.put("filecliente", sendRequest);
        if (response.data.status) {
          return response.data.file;
        } else if (!response.data.status && response.data.validacao) {
          return { enviado: false };
        } else {
          return { enviado: false };
        }
      } catch (error) {
        console.log("Erro ao tentar enviar arquivo para api");
        reject;
      }
    },
    async buscarArquivos() {
      this.folderExisteDropBox = false;
      this.loadingFile = true;
      await apiClient
        .get(`filecliente/files/${this.pessoa_id}`)
        .then((response) => {
          if (response.data.status) {
            this.gravados = response.data.files;
            if (this.gravados.length > 0) this.folderExisteDropBox = true;
          } else if (!response.data.status && response.data.erro) {
            this.$toaster.error(response.data.erro);
            console.log(
              "Erro ao buscar arquivos na api \n Erro:",
              response.data.erro
            );
          }
        })
        .catch((error) => {
          console.log("Erro ao buscar arquivos na api");
        })
        .finally(() => (this.loadingFile = false));
    },
    async downloadByURL(id) {
      this.loadingFile = true;
      var dados = {};
      if (id) {
        await apiClient
          .get(`uploadCliente/download/url/${id}`)
          .then((response) => {
            if (response.data.status) {
              dados = response.data;
            } else {
              reject(response.data.erro);
            }
          })
          .catch((error) => {
            console.log("Erro ao buscar arquivo na api");
          })
          .finally(() => (this.loadingFile = false));
      }
      return dados;
    },
    async downloadByFile(item) {
      var dados = null;
      if (item.id) {
        item.downloadFile = true;
        item.progressFile = 0;
        await apiClient
          .get(`uploadCliente/download/file/${item.id}`, {
            responseType: "arraybuffer",
            onDownloadProgress: (progressEvent) => {
              var percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              item.progressFile = percentCompleted;
            },
          })
          .then((response) => {
            if (response.data) {
              dados = response.data;
            } else {
              reject(response.data.erro);
            }
          })
          .catch((error) => {
            console.log("Erro ao buscar arquivo na api");
          })
          .finally(() => (item.downloadFile = false));
      }
      return dados;
    },

    async removeFile(item, index) {
      this.resetErros();
      if (!item.id) {
        this.images.splice(index, 1);
        return;
      }
      item.isMultiSelecionado = true;
      await this.removeVariosFilesSelecionados();
    },

    async removeVariosFilesSelecionados() {
      this.resetErros();
      var arquivos = this.retornaIDItensSelecionados(this.images);
      if (!arquivos) {
        this.$toaster.error("Nenhum arquivo selecionado para excluir");
        return;
      }

      this.$dialog
        .confirm(
          "Após excluído, Arquivos Selecionados não pode ser recuperados. Deseja continuar?",
          { loader: true, okText: "Sim", cancelText: "Não" }
        )
        .then(async (dialog) => {
          await apiClient
            .post(`filecliente/delete`, {
              files: arquivos,
              pessoa_id: this.pessoa_id,
            })
            .then((response) => {
              if (response.data.status) {
                //var excluidos = response.data.excluidos
                let novoArrayImagens = this.images.filter(
                  (item) => !item.isMultiSelecionado
                );
                this.images = novoArrayImagens;
                //this.$refs.arquivosCliente.getFilesCliente()
              } else {
                let erro =
                  "Um erro inesperado ocorreu ao tentar excluir arquivos selecionados";
                this.commitErro({ erros: erro });
              }
            })
            .catch((error) => {
              let erro =
                "Um erro inesperado ocorreu ao tentar excluir arquivos selecionados";
              this.commitErro({ erros: erro });
              this.$toaster.error("Erro ao excluir Arquivos Selecionados");
              console.log(error);
            })
            .finally(() => dialog.close());
        })
        .catch((e) => {
          //this.$toaster.error('Exclusão de Colaborador Cancelada!');
          console.log(e);
        });

      return;
    },

    retornaIDItensSelecionados(array) {
      var selecionados = [];
      array.forEach((item) => {
        if (item.isMultiSelecionado) {
          let obj = {
            id: item.id,
            file: `${item.nome}.${item.ext}` || "",
            pessoa_id: item.pessoa_id,
            path_lower: item.path_lower,
          };
          selecionados.push(obj);
        }
      });
      return selecionados;
    },

    async urltoFile(url, filename, mimeType) {
      mimeType = mimeType || (url.match(/^data:([^;]+);/) || "")[1];
      return fetch(url)
        .then(function (res) {
          return res.arrayBuffer();
        })
        .then(function (buf) {
          return new File([buf], filename, { type: mimeType });
        });
    },
    async gravarDescricao() {
      if (!(await this.validaForm())) return false;

      this.resetErros();
      var objSend = [];
      for (let i = 0; i < this.images.length; i++) {
        if (this.images[i].id > 0) {
          let item = { id: this.images[i].id, name: this.images[i].nome };
          objSend.push(item);
        }
      }
      await apiClient
        .post(`uploadCliente`, {
          files: objSend,
        })
        .then((response) => {
          if (response.status) {
          } else if (!response.data.status && response.data.validacao) {
            let erros = erroArrayToString(response.data.erros);
            this.commitErro({ erros: erros });
          } else if (response.data.erro) {
            this.commitErro({ erros: response.data.erro });
          }
        })
        .catch((error) => {
          console.log("Erro ao buscar arquivo na api");
          this.commitErro({ erros: "Erro ao acessar Api" });
        })
        .finally();
    },
  },
  computed: {
    contadorEnviar() {
      var cont = 0;
      for (let i = 0; i < this.images.length; i++) {
        if (this.images[i].isEnviar === true) cont += 1;
      }
      return cont;
    },
    contadorDownload() {
      var cont = 0;
      for (let i = 0; i < this.images.length; i++) {
        if (this.images[i].isMultiSelecionado === true) cont += 1;
      }
      return cont;
    },
    privilegioManutencaoArquivo() {
      return privilegiosUsuario.permitirManutencaoDocumentoCliente();
    },
  },
};
</script>
<style>
.elevationbtn {
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 5px 8px 0 rgba(0, 0, 0, 0.14),
    0 1px 14px 0 rgba(0, 0, 0, 0.12) !important;
}
</style>
<style scoped>
input[type="file"] {
  opacity: 0;
  width: 100%;
  height: 100px;
  max-height: 120px;
  position: absolute;
  cursor: pointer;
}
.filezone {
  width: 100%;
  outline: 2px dashed grey;
  outline-offset: -10px;
  background: #ccc;
  color: dimgray;
  padding: 10px 10px;
  min-height: 50px;
  max-height: 100px;
  position: relative;
  cursor: pointer;
}
.filezone:hover {
  background: #c0c0c0;
}

.filezone p {
  font-size: 1.2em;
  text-align: center;
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/Cliente/ArquivosCliente.vue